var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustracaoErro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 159.21 103.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0c326f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Gradiente_sem_nome_3-3);\n      }\n\n      .cls-15 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: url(#Gradiente_sem_nome_3-2);\n      }\n\n      .cls-4 {\n        fill: #ff8c00;\n      }\n\n      .cls-5 {\n        fill: #fdf5e6;\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: #e52207;\n      }\n\n      .cls-8 {\n        fill: url(#Gradiente_sem_nome_6);\n      }\n\n      .cls-9 {\n        fill: #f08080;\n      }\n\n      .cls-10 {\n        fill: url(#Gradiente_sem_nome_4);\n      }\n\n      .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-12 {\n        fill: url(#Gradiente_sem_nome_3);\n      }\n\n      .cls-13 {\n        fill: url(#Gradiente_sem_nome_6-2);\n      }\n\n      .cls-14 {\n        fill: #1351b4;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    "data-name": "Gradiente sem nome 3",
    x1: 7563.15,
    y1: -332.94,
    x2: 7552.54,
    y2: -350.73,
    gradientTransform: "translate(7577.57 -293.22) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5992ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155bcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    "data-name": "Gradiente sem nome 3",
    x1: 7537.92,
    y1: -294.96,
    x2: 7493.54,
    y2: -392.08,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-3",
    "data-name": "Gradiente sem nome 3",
    x1: 6352.13,
    y1: 384.3,
    x2: 6306.97,
    y2: 285.47,
    gradientTransform: "translate(3428.93 -5321.69) rotate(118.72)",
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    x1: 7425.17,
    y1: -345.58,
    x2: 7570.73,
    y2: -345.58,
    gradientTransform: "translate(7577.57 -293.22) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d4eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    "data-name": "Gradiente sem nome 6",
    x1: 69.94,
    y1: -386.89,
    x2: 93.31,
    y2: -386.89,
    gradientTransform: "translate(0 -293.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f174d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2bb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-2",
    "data-name": "Gradiente sem nome 6",
    x1: 40.42,
    y1: -375.98,
    x2: 122.82,
    y2: -375.98,
    xlinkHref: "#Gradiente_sem_nome_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor",
    className: "cls-12",
    d: "M16.18,38.43c-6.78,3.63-9.61,13.07-4.44,22.31,1.3,2.32,3.28,3.85,5.24,3.43,4.55-.97,6.22-10.5,10.58-12.32,1.05-.44,2.19-.38,3.19-1.06,5.48-3.76-2.28-18.93-14.57-12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-2",
    className: "cls-3",
    d: "M31.18,66.02c12.84,27.12,37.26,40.4,54.44,32.27,17.19-8.14,20.64-34.62,7.8-61.74C80.58,9.43,56.23-5.96,39.04,2.18c-17.19,8.14-20.71,36.72-7.87,63.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3",
    className: "cls-2",
    d: "M87.93,102.9c29.95,1.77,58.93-12.98,60.05-31.97s-22.25-35.81-52.2-37.58c-29.95-1.77-55.15,12.18-56.27,31.16-1.12,18.98,18.47,36.61,48.42,38.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-4",
    className: "cls-10",
    d: "M134.96,8.56C123.94,2.53,110.78.5,98.45,2.93c-12.33,2.43-23.73,9.3-31.65,19.05-5.29,6.52-9.17,14.38-15.92,19.37-6.78,5.02-15.46,6.42-23.58,8.7-15.49,4.35-24.43,15.68-18.74,27.81,6.36,13.57,21.44,14.75,31.14,17.38,11.05,3,24.71,9.83,40.14,6.8,12.74-2.5,23-15.76,34.05-22.54,13.25-8.13,23.77-9.89,32.37-21.8,12.19-16.89,5.08-40.17-11.31-49.14h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "padroes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M150.94,61.83c-.28-.2-.34-.59-.14-.87.48-.66.94-1.34,1.37-2.03.18-.29.56-.38.86-.19.29.18.38.57.19.86-.45.71-.92,1.41-1.41,2.09-.12.17-.31.26-.51.26-.13,0-.25-.04-.36-.12h0ZM154.4,56.3c-.31-.15-.43-.53-.28-.83.36-.73.7-1.48,1.01-2.23.13-.32.5-.47.81-.34s.47.5.34.81c-.32.77-.67,1.54-1.04,2.3-.11.22-.33.35-.56.35-.09,0-.19-.02-.27-.06h0ZM156.87,50.28c-.33-.1-.52-.44-.42-.77.23-.78.44-1.57.62-2.37.08-.33.41-.54.74-.47.33.08.54.41.47.74-.19.82-.4,1.64-.64,2.44-.08.27-.33.45-.59.45-.06,0-.12,0-.18-.03h0ZM158.29,43.93c-.34-.04-.58-.35-.54-.69.1-.8.16-1.62.21-2.43.02-.34.32-.61.65-.59.34.02.61.31.59.65-.05.84-.12,1.68-.21,2.51-.04.32-.31.55-.61.55-.03,0-.05,0-.08,0h0ZM157.97,36.83c-.04-.81-.11-1.63-.19-2.44-.04-.34.21-.65.55-.69.34-.03.65.21.69.55.09.83.16,1.68.2,2.51.02.34-.25.64-.59.65h-.03c-.33,0-.6-.26-.62-.59h0ZM157.15,30.47c-.05-.21-.09-.43-.14-.64-.13-.58-.28-1.17-.43-1.74-.09-.33.11-.67.44-.76s.67.11.76.44c.16.59.31,1.2.45,1.79.05.22.1.44.14.66.07.34-.14.66-.48.74-.04,0-.08.01-.13.01-.29,0-.55-.2-.61-.49ZM155.35,24.3c-.29-.76-.6-1.52-.93-2.26-.14-.31,0-.68.32-.82.31-.14.68,0,.82.32.34.76.66,1.55.96,2.33.12.32-.04.68-.36.8-.07.03-.15.04-.22.04-.25,0-.49-.15-.58-.4h0ZM152.62,18.5c-.4-.7-.83-1.41-1.28-2.09-.19-.29-.11-.67.18-.86.29-.19.67-.11.86.18.46.7.9,1.43,1.31,2.15.17.3.07.68-.23.85-.1.05-.2.08-.31.08-.21,0-.43-.11-.54-.32h0ZM149.01,13.19c-.51-.63-1.05-1.26-1.59-1.86-.23-.25-.21-.64.04-.88.25-.23.65-.21.88.04.56.62,1.12,1.26,1.65,1.91.21.27.17.66-.09.88-.11.09-.25.14-.39.14-.18,0-.36-.08-.48-.23ZM144.59,8.55c-.61-.54-1.24-1.06-1.88-1.57-.27-.21-.32-.6-.11-.87.21-.27.6-.32.87-.11.66.51,1.31,1.06,1.94,1.62.26.23.28.62.05.88-.12.14-.29.21-.46.21-.15,0-.29-.05-.41-.16h0ZM139.46,4.71c-.69-.43-1.4-.84-2.11-1.22-.3-.16-.42-.54-.26-.84s.54-.42.84-.26c.74.4,1.47.82,2.18,1.26.29.18.38.56.2.85-.12.19-.32.29-.53.29-.11,0-.23-.03-.33-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M26.44,97.38c-.87-.17-1.67-.35-2.45-.53-.33-.08-.54-.41-.46-.74.08-.33.42-.54.74-.46.76.18,1.55.35,2.41.52.34.07.56.4.49.73-.06.29-.32.5-.61.5-.04,0-.08,0-.12-.01h0ZM20.05,95.76c-.82-.27-1.62-.55-2.38-.85-.32-.13-.48-.49-.35-.81s.49-.48.81-.35c.74.29,1.51.57,2.3.82.33.11.51.45.4.78-.08.26-.33.43-.59.43-.06,0-.13,0-.19-.03h0ZM13.95,93.17c-.75-.41-1.48-.85-2.17-1.32-.29-.19-.36-.58-.17-.86.19-.29.58-.36.86-.17.66.44,1.36.87,2.07,1.26.3.16.41.54.24.84-.11.21-.32.32-.54.32-.1,0-.2-.03-.3-.08h0ZM8.54,89.3c-.62-.57-1.22-1.19-1.78-1.82-.23-.26-.2-.65.05-.88.26-.23.65-.2.88.05.53.6,1.1,1.18,1.69,1.73.25.23.27.63.03.88-.12.13-.29.2-.45.2-.15,0-.3-.05-.42-.16h0ZM4.27,84.19c-.45-.7-.88-1.44-1.28-2.19-.16-.3-.04-.68.26-.84.3-.16.68-.04.84.26.38.72.79,1.43,1.22,2.1.19.29.1.67-.19.86-.11.07-.22.1-.34.1-.21,0-.4-.1-.52-.29h0ZM1.35,78.22c-.28-.81-.52-1.63-.72-2.45-.08-.33.13-.67.46-.75.33-.08.67.13.75.46.19.77.41,1.55.68,2.32.11.32-.06.68-.38.79-.07.03-.14.03-.21.03-.26,0-.5-.16-.58-.42h0ZM.03,71.68c-.02-.39-.03-.78-.03-1.17,0-.46.01-.93.04-1.38.02-.34.32-.61.66-.58.34.02.6.32.58.66-.03.43-.04.87-.04,1.31,0,.37,0,.74.03,1.1.02.34-.24.64-.59.65h-.03c-.33,0-.6-.26-.62-.59h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-5",
    className: "cls-8",
    d: "M93.31,102.92h-23.37l4.67-18.52h14.02l4.68,18.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    className: "cls-6",
    d: "M90.26,90.85h-17.28l1.62-6.45h14.02l1.63,6.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-6",
    className: "cls-5",
    d: "M122.83,32.48v52.38c0,1.71-1.38,3.09-3.09,3.09H43.51c-1.71,0-3.09-1.38-3.09-3.09v-52.38c0-1.71,1.38-3.09,3.09-3.09h76.23c1.7,0,3.09,1.38,3.09,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-2",
    className: "cls-6",
    d: "M122.83,47.92v-15.44c0-1.71-1.38-3.09-3.09-3.09H43.51c-1.71,0-3.09,1.38-3.09,3.09v15.44s82.41,0,82.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-7",
    className: "cls-9",
    d: "M122.83,39.31v-6.83c0-1.71-1.38-3.09-3.09-3.09H43.51c-1.71,0-3.09,1.38-3.09,3.09v6.83s82.41,0,82.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-8",
    className: "cls-13",
    d: "M40.42,77.57v7.29c0,1.71,1.38,3.09,3.09,3.09h76.23c1.71,0,3.09-1.38,3.09-3.09v-7.29H40.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_581",
    "data-name": "Caminho 581",
    className: "cls-4",
    d: "M54.24,71.86c-.27,0-.53-.11-.73-.3-.48-.48-1.27-.48-1.75,0-.41.4-1.06.39-1.46-.02-.39-.4-.39-1.04,0-1.44.48-.48.48-1.27,0-1.75-.41-.4-.42-1.05-.02-1.46.4-.41,1.05-.42,1.46-.02,0,0,.01.01.02.02.48.48,1.27.48,1.75,0,.4-.4,1.06-.4,1.46,0,.4.4.4,1.06,0,1.46-.48.48-.48,1.27,0,1.75.4.4.4,1.06,0,1.46-.19.19-.45.3-.73.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    "data-name": "Caminho 582",
    className: "cls-4",
    d: "M62.62,71.86c-.27,0-.53-.11-.73-.3-.48-.48-1.27-.48-1.75,0-.4.41-1.05.42-1.46.02-.41-.4-.42-1.05-.02-1.46l.02-.02c.48-.48.48-1.27,0-1.75-.42-.39-.44-1.04-.05-1.46.39-.42,1.04-.44,1.46-.05l.05.05c.48.48,1.27.48,1.75,0,.4-.41,1.05-.42,1.46-.02s.42,1.05.02,1.46l-.02.02c-.48.48-.48,1.27,0,1.75.4.4.4,1.06,0,1.46-.19.19-.45.3-.73.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    "data-name": "Caminho 583",
    className: "cls-4",
    d: "M71,71.86c-.27,0-.53-.11-.73-.3-.48-.48-1.27-.48-1.75,0-.41.4-1.06.39-1.46-.02-.39-.4-.39-1.04,0-1.44.48-.48.48-1.27,0-1.75-.41-.4-.42-1.05-.02-1.46.4-.41,1.05-.42,1.46-.02l.02.02c.48.48,1.27.48,1.75,0,.4-.41,1.05-.42,1.46-.02.41.4.42,1.05.02,1.46l-.02.02c-.48.48-.48,1.27,0,1.75.4.4.4,1.06,0,1.46-.19.19-.45.3-.73.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_584",
    "data-name": "Caminho 584",
    className: "cls-1",
    d: "M111.18,68.31h-32.38c-.57,0-1.03-.46-1.03-1.03s.46-1.03,1.03-1.03h32.38c.57,0,1.03.46,1.03,1.03s-.46,1.03-1.03,1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_585",
    "data-name": "Caminho 585",
    className: "cls-1",
    d: "M111.18,72.21h-32.38c-.57,0-1.03-.46-1.03-1.03s.46-1.03,1.03-1.03h32.38c.57,0,1.03.46,1.03,1.03s-.46,1.03-1.03,1.03h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "objeto-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    "data-name": "Caminho 574",
    className: "cls-11",
    d: "M48.04,35.53c-.58,0-1.04-.47-1.04-1.04h0v-.03c0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04v.03c0,.58-.47,1.04-1.04,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    "data-name": "Caminho 575",
    className: "cls-11",
    d: "M52.06,35.53c-.58,0-1.04-.47-1.04-1.04h0v-.03c0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04v.03c0,.58-.47,1.04-1.04,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    "data-name": "Caminho 576",
    className: "cls-11",
    d: "M56.08,35.53c-.58,0-1.04-.47-1.04-1.04h0v-.03c0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04v.03c0,.58-.47,1.04-1.04,1.04h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 70.76,
    y: 31.67,
    width: 24.52,
    height: 24.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.02,21.25c-11.34,0-20.52,9.19-20.52,20.52s9.19,20.52,20.52,20.52,20.52-9.19,20.52-20.52-9.19-20.52-20.52-20.52ZM93.08,47.16c.39.39.39,1.02,0,1.41l-3.28,3.27c-.39.39-1.02.39-1.41,0l-5.38-5.43-5.39,5.43c-.39.39-1.02.39-1.41,0l-3.27-3.28c-.39-.39-.39-1.02,0-1.41l5.43-5.38-5.43-5.39c-.39-.39-.39-1.02,0-1.41l3.28-3.28c.39-.39,1.02-.39,1.41,0l5.38,5.44,5.39-5.43c.39-.39,1.02-.39,1.41,0l3.28,3.28c.39.39.39,1.02,0,1.41l-5.44,5.38,5.43,5.39h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracaoErro);
export default __webpack_public_path__ + "static/media/ilustracao-erro.3fae3b1d46ce93c25779211a4e56b65f.svg";
export { ForwardRef as ReactComponent };